import React from "react";
import { Inner } from "./styles.js";
import EmissionPersonalData from "./components/form_emission_personal_data/EmissionPersonalData.js";
import EmissionPaymentMethod from "./components/form_emission_payment_method/EmissionPaymentMethod.js";
import { useNavigate } from "react-router-dom";
import { useMatomo } from "@datapunt/matomo-tracker-react";

const Step3Emission = ({ nextMainStep, step3Car, setStep3Car, isMobile }) => {
	const navigate = useNavigate();
	const { trackEvent } = useMatomo();

	const renderStep3Car = () => {
		switch (step3Car) {
			case 0:
				return (
					<EmissionPersonalData
						nextSubStep={handleSubStepSubmit}
						nextMainStep={nextMainStep}
						isMobile={isMobile}
					/>
				);
			case 1:
				return (
					<EmissionPaymentMethod
						nextSubStep={handleSubStepSubmit}
						handleFinishQuotation={handleFinishQuotation}
						isMobile={isMobile}
					/>
				);
			default:
				return null;
		}
	};

	const handleSubStepSubmit = (step) => {
		setStep3Car(step);
	};

	const handleFinishQuotation = () => {
		trackEvent({
			category: "button-click",
			action: "confirm-payment-button",
			name: "step3.issue&Payment-(2)paymentMethod",
		});
		navigate("/finishProcess");
	};

	return <Inner>{renderStep3Car()}</Inner>;
};

export default Step3Emission;
